export const isCheckoutModalEnabled = (
  isEnterpriseUser: boolean,
  isEnterpriseSelfServiceUser: boolean,
  isFreeUser: boolean | undefined,
) => {
  if (isFreeUser === undefined) return false;
  return (!isEnterpriseUser || isEnterpriseSelfServiceUser) && !isFreeUser;
};
